(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eco-mobile-video')) {
    customElements.define('eco-mobile-video', class extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.slide = this.closest('slideshow-slide');
        this.button = this.querySelector('button');
        this.inView = false;
        this.tryPlay = () => {
          const video = this.querySelector('video');
          if (!video || !this.inView || document.hidden || this.slide.getAttribute('aria-hidden') === 'true') return;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.play().then(() => { this.button.hidden = true; }).catch(() => { this.button.hidden = false; });
        };
        this.syncPlayback = () => {
          const video = this.querySelector('video');
          if (!video) return;
          if (!this.inView || document.hidden || this.slide.getAttribute('aria-hidden') === 'true') video.pause();
          else this.tryPlay();
        };
        this.syncVideo = () => {
          const video = this.querySelector('video');
          if (this.mediaQuery.matches && !video) {
            this.append(this.querySelector('template').content.cloneNode(true));
            const mounted = this.querySelector('video');
            mounted.muted = true;
            mounted.defaultMuted = true;
            mounted.playsInline = true;
            mounted.addEventListener('canplay', this.syncPlayback);
            mounted.addEventListener('playing', () => { this.button.hidden = true; });
          } else if (!this.mediaQuery.matches && video) {
            video.pause();
            video.remove();
            this.button.hidden = true;
          }
          this.syncPlayback();
        };
        this.onClick = (event) => { event.preventDefault(); event.stopPropagation(); this.tryPlay(); };
        this.button.addEventListener('click', this.onClick);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio > .5;
          this.syncPlayback();
        }, { threshold: [0, .5, .75] });
        this.observer.observe(this);
        this.slideObserver = new MutationObserver(this.syncPlayback);
        this.slideObserver.observe(this.slide, { attributes: true, attributeFilter: ['aria-hidden'] });
        document.addEventListener('visibilitychange', this.syncPlayback);
        this.mediaQuery.addEventListener('change', this.syncVideo);
        this.syncVideo();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.slideObserver?.disconnect();
        this.mediaQuery?.removeEventListener('change', this.syncVideo);
        document.removeEventListener('visibilitychange', this.syncPlayback);
        this.button?.removeEventListener('click', this.onClick);
        this.querySelector('video')?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
